<template>
  <div>
    <commBanner :obj="obj"></commBanner>
    <titleHead :headTitle="headTitle"></titleHead>
    <div class="w80 mb-30">
        <el-container>
          <el-aside width="330px">
            <sidebar></sidebar>  
          </el-aside>
          <el-main>
           <companySide v-if="type" :isButton="isButton" @release="gorelease()"></companySide>
           <headSide v-else @release="gorelease()"></headSide>
           <!--查看详情-->
            <div class="mt-30">
             <contTitle :obj="obj" :contTitle="contTitle" @onBacker="Backer()"></contTitle>
             <needsDetail :needsObj="demandObj"></needsDetail>
            </div>
            <!--浏览用户-->
            <div v-if="number == true " class="mt-30">
                  <contTitle :obj="obj1" :contTitle="contTitle2"></contTitle>
                  <pictureLeftList :list="nubmerList"  class="mt-20"></pictureLeftList> 
                  <Pagination v-show="totals>0"   :total="totals"  :page.sync="dataQuery.curPage" :limit.sync="dataQuery.limit" @pageChange="pageNumber" ></Pagination>
            </div>
            <!---->
            <div style="margin-top:20%;">
                <notList :notCode="notCode"></notList>
            </div>
  
          </el-main>       
        </el-container>  
    </div>
  </div>
</template>

<script>
import {getDemand,delDemand,eitdDemand ,eitdDemandRecruit,closedDemand,myBrowseList} from "@/api/coment";
import sidebar from '../../common/sidebar'
import headSide from '../../common/headSide'
import companySide from "../../common/companySide";
import commBanner from '../../common/commBanner'
import titleHead from  '../../common/titleHead'
import contTitle from '../../common/contTitle'
import needsDetail from '../../components/needsDetail'
import pictureLeftList from '../../components/pictureLeftList'
import Pagination from '../../components/Pagination'
import notList from '../../common/notList'
export default {
   components:{
    sidebar,headSide,companySide,commBanner,titleHead,contTitle,needsDetail,pictureLeftList,Pagination,notList
   },
   data(){
     return{
       hide:false,
       showList:true,
       contTitle:'需求详情',
       contTitle2:'浏览用户',
       headTitle:'我的需求',
       obj:{
         title:'我的需求',     
         isShow:false,
         backer:false,
         roleType:'',
         personalType:9
       },
        obj1:{
         title:'我的需求',     
         isShow:false,
         roleType:'',
         personalType:9
       },
       dataQuery:{
        curPage:1,
        limit:4,
        goodsType: 8,
        goodsId:''
      },
      totals:0,
      demandObj:{},
      notCode:false,
      number:false,
      nubmerList:[],
      isButton:false,
      type:false,
     }
   },
   created(){
     if(this.$store.state.user.userInfo !=null){
         let type = this.$store.state.user.userInfo.type;
         this.obj.roleType = type;
         if(type == 3){
            this.type = true;
            this.headTitle ='企业需求'
            this.obj.title = '企业需求'
         }
     }
     
     if(this.$route.query.id){
        this.dataQuery.goodsId = this.$route.query.id;
        this.getEitdDemand(this.$route.query.id,this.$route.query.type0);
        this.getNubmer();
     }  
   },
   methods:{
	 //返回列表
	   Backer(){
         this.$router.push('/demand')
	   },
     //发布需求
     addNeeds(){
        this.showList = false;
        this.obj.backer = false;
        this.notCode = false;
        this.$router.push('/demandAdd')
     },
     //编辑需求
     onEdit(row){
       this.showList = false;
       this.hide = false;
       this.$router.push({
         path:'/demandAdd',
         query:{
           id:row.id
         }
       });
     },
      //获取需求详情
      getEitdDemand(id,type){
      let params ={demandId:id};
        if(type == 1){
          eitdDemand(params).then(res=>{
            console.log("获取需求详情")
            console.log("需求类型：",this.$route.query.type0)
            console.log(res)
            if(res.code ==0){
              this.demandObj = res.data;
              this.obj.backer = true;
            }
          }).catch(err=>{});
        }else{
          eitdDemandRecruit(params).then(res=>{
            console.log("获取需求详情")
            console.log("需求类型：",this.$route.query.type0)
            console.log(res)
            if(res.code ==0){
              this.demandObj = res.data;
              this.obj.backer = true;
            }
          }).catch(err=>{});
        }
      },
    //浏览人数列表
    getNubmer(){
      myBrowseList(this.dataQuery).then((res)=>{
        if(res.code ==0){
          this.nubmerList = res.page.list;
          this.totals = res.page.totalCount;
          res.page.list.length >0 ? this.number = true : this.number = false;     
        }
      }).catch((err)=>{})
    },
    //分页
    pageNumber(item){
      this.dataQuery['curPage'] = item.page;
      this.dataQuery['limit'] = item.limit;
      this.getNubmer();
    }
   }
}
</script>

<style scoped>
.pl-15{
  padding-left: 15px;
}

.dn{
  display: none;
}

.mt-15{
  margin-top: 15px;
}
.mt-20{
  margin-top: 20px;
}
</style>


// WEBPACK FOOTER //
// src/view/coment/demandDetail.vue